import Axios from "axios";
import { ResourceGenerator } from "@swan/api";

const Service = ResourceGenerator(Axios, "analytics");

export default Service;
